import { createClient } from "tinacms/dist/client";
import { queries } from "./types";
export const client = createClient({ cacheDir: "/vercel/path0/tina/__generated__/.cache/1742378234109", url: "https://content.tinajs.io/1.5/content/9494cc66-b36b-498a-81d9-35ab0f754918/github/main", token: "0b8e806b312bc372163c58dac018a04e501e026a", queries });
export default client;
